export const getLabelForSuggestedLocation = (label?: string) => {
    if (!label) return '';
    const result = label?.split(',');
    result.pop();

    return result.join(',');
  };